export const signInLocators = {
  ehSignInButton: 'Signin-EH-LoginButton',
  paywallParaElement: 'Signin-Paywall-TextDescription',
} as const;
